import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/button";
import Input from "../../components/input";
import Navbar from "../../components/navbar";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { userSignUp } from "../../hooks/local/reducer";
// import { showSuccessMessage } from "../../hooks/constants";
import signIn from "../../assets/icons/signIn.svg";
import { useState } from "react";
import Lottie from "lottie-react";
import animationData from "../../assets/animations/messageAnimation_2.json"

const CreateAccount = () => {

  const [signUpSuccessModal, setSignUpSuccessModal] = useState(false);

  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const loading = useSelector((state) => state.user.loading);
  document.title = `${loading? "Mosquepay" : "Create an account - Mosquepay"}`;

  const signUpForm = useFormik({
  initialValues:{
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    password: "",
    confirmPassword: "",
  },
  validationSchema: Yup.object({
    firstname: Yup.string().required("First name cannot be empty"),
    lastname: Yup.string().required("Last name cannot be empty"),
    email: Yup.string()
      .required("Please provide an email address")
      .email("Please enter a valid emaill address"),
    phonenumber: Yup.number()
      .required("Phone Number cannot be empty")
      .typeError("Invalid Phone Number Format")
      .max(9999999999, "Phone Number has to be 11 digit")
      .min(999999999, "Phone Number has to be 11 digit"),
    password: Yup.string()
      .required("Password is required")
      // .matches(
      //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@.$!%#?&])[A-Za-z\d@.$!%*#?&]{8,}$/,
      //   "Please check password requirement information"
      // )
      ,
    confirmPassword: Yup.string()
      .required("Confirm Password!")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  }),
  onSubmit: async(values, {resetForm}) => {
    const {firstname, lastname, email, phonenumber, password} = values; 
    let signUpData = {firstname, lastname, email, phonenumber, password};
    const {payload} = await dispatch(userSignUp(signUpData));
    if(payload.status_code === "0") {
      // showSuccessMessage("Account created!");
      // navigate("/sign-in");
      setSignUpSuccessModal(true)
      // resetForm(); taking this off because i still want access to the users email address
    }
  }
  })

    return (
      <div className="bg-signInPattern bg-[length:24%]">
        <div className="bg-white/80 min-h-screen flex items-center pt-24 pb-16">
          {/* navbar */}
          <Navbar />
          <div className="px-4 md:px-12 grid grid-cols-1 lg:grid-cols-5 gap-4 w-full">
            <div className="bg-white rounded border lg:col-span-3 p-4 md:p-10">
              <p className="font-semibold">Create an account.</p>
              <p className="text-secondary leading-tight mt text-sm">
                Create an account now and start giving back to your community
                with confidence.
              </p>
              <form
                onSubmit={signUpForm.handleSubmit}
                className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4"
              >
                <Input
                  type={"text"}
                  label={"First name"}
                  placeholder={"Muhammad"}
                  name={"firstname"}
                  value={signUpForm.values.firstname}
                  onChange={signUpForm.handleChange}
                  onBlur={signUpForm.handleBlur}
                  onError={
                    signUpForm.touched.firstname && signUpForm.errors.firstname
                      ? signUpForm.errors.firstname
                      : null
                  }
                />
                <Input
                  type={"text"}
                  label={"Last name"}
                  placeholder={"Ali"}
                  name={"lastname"}
                  value={signUpForm.values.lastname}
                  onChange={signUpForm.handleChange}
                  onBlur={signUpForm.handleBlur}
                  onError={
                    signUpForm.touched.lastname && signUpForm.errors.lastname
                      ? signUpForm.errors.lastname
                      : null
                  }
                />
                <Input
                  type={"email"}
                  label={"Email address"}
                  placeholder={"Ali@gmail.com"}
                  name={"email"}
                  value={signUpForm.values.email}
                  onChange={signUpForm.handleChange}
                  onBlur={signUpForm.handleBlur}
                  onError={
                    signUpForm.touched.email && signUpForm.errors.email
                      ? signUpForm.errors.email
                      : null
                  }
                />
                <Input
                  type={"tel"}
                  label={"Phone number"}
                  name={"phonenumber"}
                  value={signUpForm.values.phonenumber}
                  onChange={signUpForm.handleChange}
                  onBlur={signUpForm.handleBlur}
                  onError={
                    signUpForm.touched.phonenumber &&
                    signUpForm.errors.phonenumber
                      ? signUpForm.errors.phonenumber
                      : null
                  }
                />
                <Input
                  type={"password"}
                  label={"Password"}
                  isPassword={"true"}
                  name={"password"}
                  value={signUpForm.values.password}
                  onChange={signUpForm.handleChange}
                  onBlur={signUpForm.handleBlur}
                  onError={
                    signUpForm.touched.password && signUpForm.errors.password
                      ? signUpForm.errors.password
                      : null
                  }
                />
                <Input
                  type={"password"}
                  label={"Confirm password"}
                  name={"confirmPassword"}
                  isPassword={"true"}
                  value={signUpForm.values.confirmPassword}
                  onChange={signUpForm.handleChange}
                  onBlur={signUpForm.handleBlur}
                  onError={
                    signUpForm.touched.confirmPassword &&
                    signUpForm.errors.confirmPassword
                      ? signUpForm.errors.confirmPassword
                      : null
                  }
                />

                <Button
                  buttonText={"Create account"}
                  icon={signIn}
                  loading={loading}
                  otherStyles={"bg-black text-white"}
                />
              </form>
              <p className="mt-6">
                I already have an account?{" "}
                <Link to={"/sign-in"} className="underline text-brandGreen ps-1">Sign in</Link>
              </p>
            </div>
            <div className="lg:col-span-2 p-4 md:p-10">
              <div className="h-full flex items-center">
                <div className="text-center lg:text-start">
                  <p>
                    “Those who spend their wealth in Allah’s cause are like
                    grains of corn which produce seven ears, each bearing a
                    hundred grains.”
                  </p>
                  <p className="font-bold mt-2">Qur’an, 2:261</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {signUpSuccessModal && (
          <div className="bg-black/80 fixed top-0 z-50 w-full h-full transition-all duration-300 flex items-center justify-center">
            <div className="bg-white rounded-md border border-[#c4c4c424] w-full md:w-1/2 m-4 py-10 px-4 md:px-8 overflow-y-auto">
             <div className="flex justify-center">
               <Lottie animationData={animationData} loop={true} className="w-40"/>
             </div>
             <p className="font-bold text-center mb-2 mt-6">One More Step: Verify Your Email!</p>
              <p className="text-center pb-10">Thanks for signing up! We’ve just sent a verification email to <span className="font-medium underline text-brandGreen">{signUpForm.values.email}</span>. <br />
                To finish setting up your account, please click the link in that email. Once you're verified, you’ll be all set to explore and enjoy our services!
              </p>
              <div className="flex justify-center">
                <Link to={"/sign-in"} className="underline text-brandGreen">Back to home page</Link>
              </div>
            </div>
          </div>
        )}
      </div>
    );
}
 
export default CreateAccount;